'use client';

import LoginWithOTP from '@/components/LoginWithOTP';
import { signIn } from "next-auth/react";

function Button({ onClick, label, props }) {
    return <button className='bg-blue-600 text-white px-4 py-2 rounded-md my-2' {...props} onClick={onClick}>Login with {label}</button>
}

function Hr() {
    return <hr className='w-full border-neutral-400 my-2' />
}

export default function Login() {
    if (process.env.NEXT_PUBLIC_NODE_ENV !== 'development') {
        signIn('azure-ad', { callbackUrl: '/' });
        return null
    }
    return (
        <div className='flex flex-col mt-6 w-80 rounded-lg py-4 items-center justify-center mx-auto bg-slate-500 px-4'>
            <h1 className='text-5xl my-4'>Login</h1>

            <LoginWithOTP />
            <Hr />
        </div>
    )
}
